export const EN_GB_LOCALE = 'en-GB';
